/**
 * Даты, ссылки и правила лендинга. Боевое окно начисления билетов — в `server/lib/ticket-config.ts`,
 * окно розыгрыша — в `server/lib/draw-config.ts`; здесь только то, что показывает фронт.
 *
 * AICODE-NOTE: даты лендинга (начисление с 3 ноября по 30 декабря, открытие козочек и финальный эфир
 * 5 января 2027, работа лендинга до 5 января 23:59, выдача призов до 28 февраля) подтверждены заказчиком
 * 26.10.2026 — см. docs/business.md, «Сроки». Расхождения дев-макета с паспортом этим сняты.
 */
export const LANDING_DATES = {
  /** Конец начисления козочек — таймер на первом экране (30 декабря 24:00 мск). */
  accrualEnd: '2026-12-31T00:00:00+03:00',
  /** Финальный эфир: автомобиль и ценные призы. */
  finalDraw: '2027-01-05T12:00:00+03:00',
  /** Лендинг работает до 5 января 23:59:59 мск; с этого момента — экран «Акция завершена». */
  landingEnd: '2027-01-06T00:00:00+03:00',
} as const;

export const LANDING_LINKS = {
  /** Личный кабинет NL — туда уходит всё о призах после окончания лендинга. */
  cabinet: 'https://ng.nlstar.com/',
} as const;

/** Каждые N козочек (goatsTotal) = 1 шанс в розыгрыше авто. */
export const GOATS_PER_CHANCE = 12;
